import { useState, useEffect } from 'react';
import {PostByAggWithAuth} from '../../utils/axios';
import classNames from 'classnames';
import { capitalizeWords, getDateRange } from '../../helper/CustomHelper'


const FILTER_OPTIONS = [
    // { Song: 'All', value: '0', interval_day: 0 },
    { Song: 'Last 7 Day', value: '7day', interval_day: 7 },
    { Song: 'Last 1 Month', value: '1month', interval_day: 30 },
    { Song: 'Last 3 Month', value: '3month', interval_day: 90 }
];

const LookerTopFourArtist = () => {
    const [activeFilter, setActiveFilter] = useState(FILTER_OPTIONS[0]);
    const [labelData, setLabelData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchTopLabels(activeFilter.value);
    }, [activeFilter]);

    const fetchTopLabels = (rangeType) => {
        const {dateStart , dateStop} = getDateRange(rangeType)
        setLoading(true);
        PostByAggWithAuth({
            url: 'looker/v1/report/find-by-top-report',
            body: {
                "report_date_start": dateStart,
                "report_date_end": dateStop,
                "target": "artist"
            },
            onResponse: (res) => {
                console.log('API result Artist:', res);
                setLabelData(Array.isArray(res.data.data) ? res.data.data : []);
                setLoading(false);
            },
            onError: () => {
                console.log('error')
                setLabelData([]);
                setLoading(false);
            }
        });
    };

    return (
        <div className="col-12">
            <div className="mb-16 mt-8 d-flex flex-wrap justify-content-between gap-16">
                <h6 className="mb-0">Top 4 Artists</h6>
                <ul className="nav button-tab nav-pills mb-16 gap-12" role="tablist">
                    {FILTER_OPTIONS.map((opt) => (
                        <li key={opt.value} className="nav-item" role="presentation">
                            <button
                                className={classNames(
                                    'nav-link fw-semibold text-secondary-light rounded-pill px-20 py-6 border border-neutral-300',
                                    { active: activeFilter.value === opt.value }
                                )}
                                type="button"
                                onClick={() => setActiveFilter(opt)}
                            >
                                {opt.Song}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

            {loading ? (
                <div className="text-center">Loading...</div>
            ) : (
                <div className="row g-3">
                    {labelData.length > 0 ? labelData.map((item, index) => (
                        <div key={index} className="col-xxl-3 col-sm-6 col-xs-6">
                            <div className="nft-card bg-base radius-16 overflow-hidden">
                                <div className="radius-16 overflow-hidden" style={{ height: '180px' }}>
                                    <img
                                        src="https://www.shutterstock.com/shutterstock/videos/1106390253/thumb/1.jpg?ip=x480"
                                        alt={item.release_name}
                                        className="w-100 h-100 object-fit-cover"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = 'https://www.shutterstock.com/shutterstock/videos/1106390253/thumb/1.jpg?ip=x480';
                                        }}
                                    />
                                </div>
                                <div className="p-10">
                                    <h6 className="text-md fw-bold text-primary-light">
                                        {item.artist_name ? capitalizeWords(item.artist_name) : "[Artist Name]"}
                                    </h6>
                                    <div className="d-flex align-items-center gap-8 mt-10 justify-content-between">
                                        <span className="text-sm text-secondary-light fw-medium">
                                            Streams: {item.total_streams}
                                        </span>
                                        <span className="text-sm text-secondary-light fw-medium">
                                            Listeners: {item.total_listeners}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )) : (
                        <div className="text-center w-100">No data available</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default LookerTopFourArtist;
